export class StoreKeys {
  public static RepositoryPicker = "REPOSITORY_PICKER_STORE_KEY";
  public static RepositorySelector = "REPOSITORY_SELECTOR_STORE_KEY";
}

export class ActionCreatorKeys {
  public static RepositoryPicker = "REPOSITORY_PICKER_ACTION_CREATOR_KEY";
  public static RepositorySelector = "REPOSITORY_SELECTOR_ACTION_CREATOR_KEY";
}

export class ActionKeys {
  public static RepositoryPicker = "REPOSITORY_PICKER_ACTIONS_KEY";
  public static RepositorySelector = "REPOSITORY_SELECTOR_ACTIONS_KEY";
}
